import type { CancelActiveInvocationsResponse } from "@/shared/domain/actions";

/**
 * Call `cancelBatch` until the server reports nothing left to cancel, or until a round cancels
 * nothing.
 *
 * The server answers `has_more` whenever a cancel in the round failed, so a cancel that keeps
 * failing would otherwise repeat forever.
 */
export async function cancelUntilDone(
  cancelBatch: () => Promise<CancelActiveInvocationsResponse>,
): Promise<void> {
  let hasMore = true;
  while (hasMore) {
    const response = await cancelBatch();
    hasMore = response.has_more && response.success_count > 0;
  }
}
